package app.footyguide.web.locale

import app.footyguide.core.locale.UiLanguage
import kotlinx.browser.window

/**
 * Web Locale & Language manager.
 * Priority:
 * 1. User explicit stored preference (localStorage "fg-ui-language")
 * 2. System/browser preference (navigator.languages / navigator.language)
 * 3. Fallback to English (UiLanguage.default = EN)
 */
object WebLocale {
    const val STORAGE_KEY = "fg-ui-language"

    fun resolveLanguage(): UiLanguage {
        // 1. Preferência persistida do usuário
        val stored = window.localStorage.getItem(STORAGE_KEY)
        if (!stored.isNullOrBlank()) {
            return UiLanguage.fromCode(stored)
        }

        // 2. Automático do sistema: inspeciona lista de preferências do navegador
        val sysLanguages = runCatching {
            val arr = js("window.navigator.languages") as? Array<String>
            arr?.toList()
        }.getOrNull()

        if (!sysLanguages.isNullOrEmpty()) {
            for (tag in sysLanguages) {
                val detected = UiLanguage.fromSystemLanguage(tag)
                val primary = tag.trim().lowercase().split("-", "_").firstOrNull() ?: ""
                if (primary == "pt" || primary == "es" || primary == "en") {
                    return detected
                }
            }
        }

        // Fallback para navigator.language ou English default
        val primaryNav = runCatching { window.navigator.language }.getOrNull()
        return UiLanguage.fromSystemLanguage(primaryNav)
    }

    fun setLanguage(language: UiLanguage) {
        window.localStorage.setItem(STORAGE_KEY, language.code)
    }

    fun clearStoredLanguage() {
        window.localStorage.removeItem(STORAGE_KEY)
    }
}
